import { dataInitialMonthlyPayment, dataInitialFilter } from './state'

/**
 * Establecer el contenido activo en el detalle de la licencia.
 * 1: Detalles de la licencia.
 * 2: Detalles de los pagos de la licencia.
 *  
 * @param {*} state 
 * @param {*} newTab: Nuevo tab activo
 * @author Fernando CLaros Garcia
 */
export function setActivedTabMonthlyPayment(state, newTab) {
  state.activedTabMonthlyPayment = newTab;
}

/**
 * Establecer si el formulario par agregar pagos esta visible o no.
 * true: Visible.
 * false: No visible.
 * 
 * @param {*} state 
 * @param {*} nextState: nuevo valor para el estado.
 * @author Fernando CLaros Garcia
 */
export function setIsShowFormMonthlyPayment(state, nextState) {
  state.isShowFormMonthlyPayment = typeof nextState === 'boolean' ? nextState : !state.isShowFormMonthlyPayment;
}

/**
 * Establecer los pagos.
 *  * 
 * @param {*} state 
 * @param {*} nextMonthlyPayments: nuevo listado de pagos
 * @author Fernando CLaros Garcia
 */
export function setMonthlyPayments(state, nextMonthlyPayments) {
  state.monthlyPayments = nextMonthlyPayments;
}

/**
 * Establecer el pago a su esatdo por defecto.
 *  * 
 * @param {*} state 
 * @author Fernando CLaros Garcia
 */
export function setDefaultMonthlyPayment(state) {
  state.monthlyPayment = dataInitialMonthlyPayment();
}

/**
 * Establecer valores para el filtro.
 *  
 * @param {*} state 
 * @author Fernando CLaros Garcia
 */
export function setDefaultFilterMonthlyPayments(state) {
  state.filter = dataInitialFilter();
}

/**
 * Establecer valores para el filtro.
 *  
 * @param {*} state 
 * @param {*} nextFilter 
 * @author Fernando CLaros Garcia
 */
export function setFilterDataMonthlyPayments(state, nextFilter) {
  state.filter = nextFilter;
}

/**
 * Establecer el pago a actual.
 *  
 * @param {*} currentPayment 
 * @param {*} state 
 * @author Fernando CLaros Garcia
 */
export function setMonthlyPayment(state, currentPayment) {
  state.monthlyPayment = currentPayment;
}
